<template>
    <tabbar :tabbar="navData"></tabbar>
</template>

<script>

    import tabbar from '@/components/Tabbar'

    export default {
        components: {
            tabbar
        },
        data() {
            return {
                navData: [
                    {
                        name: '首页',
                        path: '/main',
                        pathName: 'main',
                        icon: 'home',
                        dot: false,
                        info: '',
                    },
                    {
                        name: '报表',
                        path: '/main/utui',
                        pathName: 'utui',
                        icon: 'baobiao1',
                        dot: false,
                        info: ''
                    },
                    {
                        name: '账单',
                        path: '/user/income',
                        pathName: 'income',
                        icon: 'zhangdan',
                        dot: false,
                        info: ''
                    },
                    {
                        name: '我的',
                        path: '/user',
                        pathName: 'user',
                        icon: 'wode-copy-copy',
                        dot: false,
                        info: ''
                    }
                ]
            }
        },
        computed: {},
        methods: {}
    }
</script>
